import React from 'react';

const NAMES = {
  es: 'Spain', kr: 'South Korea', au: 'Australia', fr: 'France', us: 'United States',
  it: 'Italy', ca: 'Canada', ru: 'Russia', jp: 'Japan', za: 'South Africa',
  gb: 'United Kingdom', de: 'Germany', ch: 'Switzerland', at: 'Austria', mx: 'Mexico',
};

export default function Flag({ code, className = 'w-5 h-auto' }) {
  if (!code) return null;
  return (
    <img
      src={`https://flagcdn.com/w40/${code}.png`}
      srcSet={`https://flagcdn.com/w40/${code}.png 1x, https://flagcdn.com/w80/${code}.png 2x`}
      alt={NAMES[code] || code.toUpperCase()}
      title={NAMES[code] || code.toUpperCase()}
      loading="lazy"
      className={`inline-block rounded-[2px] shadow-[0_0_0_1px_rgba(255,255,255,0.18)] object-cover ${className}`}
    />
  );
}